import React from 'react';
import icons from '../../main/utils/icons';
import IconButton from './IconButton';

export default function ButtonSetting(props) {
  return <IconButton icon={icons.settingIcon} {...props} />;
}
